import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/common/PageHeader';

const Tesekkurler = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        title="Teşekkürler!"
        description="Mesajınız başarıyla iletildi"
        backgroundImage="/images/hero-bg.jpg"
      />
      
      <div className="container mx-auto px-4 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-2xl mx-auto bg-white p-8 rounded-2xl shadow-lg text-center"
        >
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />
          
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Mesajınız İçin Teşekkür Ederiz!
          </h2>
          
          <p className="text-gray-600 mb-8">
            En kısa sürede size geri dönüş yapacağız. Başka sorularınız varsa bize ulaşmaktan çekinmeyin.
          </p>
          
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-block bg-[#c8bca4] text-white px-6 py-3 rounded-lg transition-colors hover:bg-[#b5a791]"
            >
              Ana Sayfaya Dön
            </Link>
            
            <div className="pt-6 border-t mt-6">
              <p className="text-gray-500 text-sm">
                Acil durumlar için: <a href="tel:+905387416525" className="text-[#c8bca4] hover:text-[#b5a791]">0538 741 65 25</a>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Tesekkurler; 